/**
 * A chart value as a Date. The time axis hands its tick labels over as DATE-ONLY strings ('2026-10-10'), which `new Date`
 * reads as UTC midnight — the evening BEFORE west of UTC, so every tick read a day early (a 10 Oct check-in under "9 Oct";
 * found on the E43 check-in rows, 2026-10-10). A date-only value is the local calendar day; a date-time and an epoch
 * number are taken as they are.
 */
export const dateOf = (v: unknown): Date => {
  const n = Number(v);
  if (!Number.isNaN(n)) return new Date(n);
  const day = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(v));
  return day ? new Date(Number(day[1]), Number(day[2]) - 1, Number(day[3])) : new Date(String(v));
};
